const Number = [];

for (let i = 1; i <= 200; i++) {
  Number.push({
    quizNo: i,
    name: 'Quiz',
  });
}

export default Number;